import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active' ? true : false
        }
    }
    return ApiService.get('/transport/transport-users/', datas)
}
export const createApiRecord = (data) =>
    ApiService.post('/transport/transport-users/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/transport/transport-users/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.put(`/transport/transport-users/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/transport/transport-users/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/transport/transport-users', id)
